import { toast } from 'sonner';

// Navega al registro referenciado por el backend ({ route, ids, month, month_param }) resaltándolo con ?ref=
export const goToReference = (navigate, ref) => {
  if (!ref?.exists) { toast.info(ref?.reason || 'Sin referencia disponible'); return; }
  if (ref.month && !ref.month_param) {
    const [y, m] = ref.month.split('-').map((x) => parseInt(x, 10));
    sessionStorage.setItem('finances_selected_period', JSON.stringify({ month: m - 1, year: y }));
  }
  const [path, qs] = ref.route.split('?');
  const params = new URLSearchParams(qs || '');
  params.set('ref', (ref.ids || []).join(','));
  if (ref.month && ref.month_param) params.set(ref.month_param, ref.month);
  navigate(`${path}?${params}`);
};

// Deep link al contrato (Contratos redirige a Terminados si ya no está vigente) con resaltado azul
export const contractPath = (contractId) => `/app/contracts?focus=${contractId}`;
